<template>
  <div v-if="showStoreHours" class="store-hours">
    <h4>{{ "dealers.details.storeHours" | t }}</h4>
    <table>
      <tbody>
        <tr v-for="(time, date) in storeHours" :key="`${date}`">
          <td v-if="date != 'today'" class="date">{{ getDateName(date) }}</td>
          <td v-if="date != 'today' && (time.open == null || time.close == null)" class="date">{{ "dealers.details.storeClosed" | t }}</td>
          <td v-if="date != 'today' && (time.open != null || time.close != null)">{{ time.open | toTime }} - {{ time.close | toTime }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: 'StoreHours',
  props: {
    storeHours: {
      type: Object
    }
  },
    computed: {
    ...mapGetters("DealerHeader", [
      "showStoreHours",
    ]),
    },
  methods: {
    getDateName(date) {
      return this.$options.filters.t("dealers.details.storeHours." + date);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .store-hours {
    width: 100%;
    margin-bottom: 40px;
    flex-direction: column;
    
    h4 {
      font-family: $font-title;
      font-size: 1.285em;
      line-height: 1.285em;
      border-bottom: 1px solid #c8c8c8;
      text-align: left;
      padding: 0 0 10px;
      margin: 0 0 23px;
    }
    .date {
      font-family: $font-text;
      text-transform: capitalize;
    }
    table {
      width: 50%;
      line-height: 28px;
      border-collapse: collapse;
      border-spacing: 0;
      flex-wrap: wrap;
      padding-bottom: 0;
      color: $text-muted;
      font-size: 1.142em;
    }
    table tr { 
      border: none;
      text-align: left;
      background-color: #ffffff;
    }
    table tr td {
      padding: 0;
      text-transform: lowercase;
    }
    table tr td:last-of-type {
      font-family: $font-text;
      color: #000000;
      line-height: 28px;
      font-weight: bold;
      text-align: right;
    }
    @media only screen and (max-width: $breakpoint-md) {
      table {
        width: 100%;
        margin-bottom: 15px;
      }
    }
  }
</style>
